import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ControlledTable from "../../../component/ControlledTable";
import { useDispatch, useSelector } from "react-redux";
import { commissionListTable as tableDef } from "../../../config/grid-columns-defs";
import { handleAxiosError } from "../../../config/action-config";
import { Controller, useForm } from "react-hook-form";
import { showAlert } from "../../../actions/alert";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@material-ui/core";
import {
  createCommission,
  getCommissionsList,
  getCompanyList,
  getPartners,
  getupdatecommissionCompanyList,
} from "../../../api/commissions";
import { getPartnersDropdownList } from "../../../api/partnerList";
const useStyles = makeStyles((theme) => ({
  textfeild: {
    "& .MuiFilledInput-root": {
      color: "#fff !important",
    },
  },
}));

export default function CommisionsList() {
  const classes = useStyles();
  let obj = tableDef.find((o) => o.headerName === "Action");
  const user = useSelector((state) => state.user);
  const dialogAction = useSelector((state) => state.dialog);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [totalCount, setTotalCount] = useState(0);
  const [rows, setRows] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const [partnerName, setPartnerName] = useState("");
  addAdditionalColumn(obj, dispatch);
  useEffect(() => {
    if (!dialogAction.type) return;
    switch (dialogAction.type) {
      case "VIEW":
        dispatch({ type: "" });
        navigate(`${dialogAction.data.commission_id}`);
        break;
      default:
        break;
    }
  }, [dialogAction]);
  useEffect(() => {
    refreshTable();
  }, [partnerName]);
  const getRows = async (numRows, startRow) => {
    return getCommissionsList(
      { limit: numRows, offset: startRow, partnername: "" },
      user.token
    )
      .then((res) => {
        setTotalCount(parseInt(res.data.total) === 0 ? -1 : res.data.total);
        return res.data.data;
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
        return [];
      });
  };
  const refreshTable = async () => {
    try {
      const { data } = await getCommissionsList(
        { limit: 10, offset: 0, partnername: partnerName },
        user.token
      );
      setTotalCount(parseInt(data.total) === 0 ? -1 : parseInt(data.total));
      setRows(data.data);
    } catch (err) {
      handleAxiosError(err, dispatch);
    }
  };

  return (
    <Box className="pmt-container-box">
      <Box className="pmt-title-box">
        <Box className="typography-title">
          <Typography variant="h1" className="pmt-headings-h1">Commissions</Typography>
        </Box>

        <Button
          variant="contained"
          style={{ padding: "5px 7px" }}
          sx={{
            fontSize: { xs: "10px", sm: "12px" }
          }}
          onClick={() => {
            setCreateDialogOpen(true);
          }}
          className="blue-button"
        >
          Add Commission
        </Button>
      </Box>
      <br />
      <Box className="pmt-filter-box">
        <Grid
          container
          className="report-filter-box"
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 1, md: 1 }}
        >
          <Grid item lg={2} md={2} sm={4} xs={12}>
            <TextField
              className={classes.textfeild}
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={partnerName}
              label="Partner Name"
              size="small"
              fullWidth
              onChange={(e) => {
                setPartnerName(e.target.value);
              }}
            />
          </Grid>
        </Grid>
      </Box>
      <div className="pmt-controll-table">
        <ControlledTable
          rows={rows}
          columnDefs={tableDef}
          getRows={getRows}
          totalCount={totalCount}
          onChange={setRows}
          onPageNumberChange={setPageNumber}
          pageSize={10}
          pageNumber={pageNumber}
          pagination={true}
          hasActionButtons={false}
        />
      </div>
      <AddCommissionDialog
        open={createDialogOpen}
        setOpen={setCreateDialogOpen}
        onRefresh={refreshTable}
      />
    </Box>
  );
}

function addAdditionalColumn(obj, dispatch) {
  if (obj === undefined) {
    tableDef.unshift({
      headerName: "Action",
      field: "actions",
      resizable: true,
      wrapText: true,
      autoHeight: true,
      minWidth: 65,
      maxWidth: 70,
      headerClass: "justify-center",
      cellClass: "justify-center",
      cellRendererFramework: (params) => (
        <IconButton
          color="info"
          onClick={() => {
            dispatch({ type: "VIEW", data: params.data });
          }}
        >
          <VisibilityIcon fontSize="inherit" />
        </IconButton>
      ),
    });
  }
}
const emptyNewCommissionData = {
  partner_id: "",
  lead_id: "",
  cloud_sales: "",
  services_sales: "",
  status: "",
  deal_value_closed: "",
};
function AddCommissionDialog({ open, setOpen, onRefresh }) {
  const user = useSelector((state) => state.user);
  const [data, setData] = useState(emptyNewCommissionData);
  const [partnerListData, setPartnerListData] = useState([]);
  const [companyListData, setCompanyListData] = useState([]);
  const [partnerId, setPartnerId] = useState("");
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm({ defaultValues: emptyNewCommissionData });

  const dispatch = useDispatch();
  useEffect(() => {
    if (open) {
      setData(emptyNewCommissionData);
    }
  }, [open]);

  async function onNewCommissionSubmit(newdata) {
    try {
      const { data } = await createCommission(newdata, user.token);
      dispatch(showAlert(data.msg));
      setOpen(false);
      onRefresh();
    } catch (err) {
      handleAxiosError(err, dispatch);
      setOpen(false);
    }
  }
  async function partnerList() {
    const token = user.token;
    try {
      const { data } = await getPartners(token);
      setPartnerListData(data.data);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }
  async function companyList() {
    let partner = partnerListData.find((p) => {
      return p.id === partnerId;
    });

    const token = user.token;
    try {
      const { data } = await getupdatecommissionCompanyList(
        token,
        partner.name
      );
      setCompanyListData(data.records);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }

  useEffect(() => {
    if (partnerId) {
      companyList();
    }
    return;
  }, [partnerId]);
  useEffect(() => {
    partnerList();
  }, []);

  return (
    <Dialog
      open={open}
      onClose={() => {
        // setOpen(true);
      }}
    >
      <DialogTitle>Create New Commission</DialogTitle>
      <Box component="form" onSubmit={onNewCommissionSubmit}>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth required error={Boolean(errors.partner_id)}>
                <InputLabel id="demo-simple-select-label-a">
                  Partner Name
                </InputLabel>
                <Controller
                  render={(props) => (
                    <Select
                      MenuProps={{ className: "select-box-height" }}
                      value={props.value}
                      onChange={(e) => {
                        props.onChange(e.target.value);
                        setPartnerId(e.target.value);
                      }}
                    >
                      {partnerListData.map((p, i) => (
                        <MenuItem key={i} value={p.id}>
                          {p.name}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                  name="partner_id"
                  control={control}
                  rules={{
                    required: "Please select Partner Name",
                  }}
                />
                <FormHelperText>{errors.partner_id?.message}</FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth required error={Boolean(errors.lead_id)}>
                <InputLabel id="demo-simple-select-label-a">
                  Company Name
                </InputLabel>
                <Controller
                  render={(props) => (
                    <Select
                      MenuProps={{ className: "select-box-height" }}
                      value={props.value} onChange={props.onChange}>
                      {companyListData.map((c, i) => (
                        <MenuItem key={i} value={c.lead_id}>
                          {c.company_name}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                  name="lead_id"
                  control={control}
                  rules={{
                    required: "Please select Company Name",
                  }}
                />
                <FormHelperText>{errors.lead_id?.message}</FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                name="deal_value_closed"
                label="Deal Value Closed"
                type="number"
                required
                fullWidth
                inputRef={register({
                  required: "Deal Value Closed is required.",
                })}
                
                error={Boolean(errors.deal_value_closed)}
                helperText={errors.deal_value_closed?.message}
              />
            </Grid>
            <Grid item xs={12}  sm={6} md={6}>
              <TextField
                name="cloud_sales"
                label="Cloud Sales"
                type="number"
                required
                fullWidth
                inputRef={register({
                  required: "Cloud Sales is required.",
                })}
                error={Boolean(errors.cloud_sales)}
                helperText={errors.cloud_sales?.message}
              />
            </Grid>
            <Grid item xs={12}  sm={6} md={6}>
              <TextField
                name="services_sales"
                label="Services Sales"
                type="number"
                
                fullWidth
                inputRef={register({
                  required: "Services Sales is required.",
                })}
                error={Boolean(errors.contact)}
                helperText={errors.contact?.message}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpen(false);
            }}
            className="cancel-button"
          >
            Cancel
          </Button>
          <Button onClick={handleSubmit(onNewCommissionSubmit)} type="submit" className="blue-button">
            Submit
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
